module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-box-bg-1-13b116d4b9b7df04274cd131d7347345.png";